/**
 * Firebase web app config from build-time env (CRA: REACT_APP_*).
 * Local dev: copy `.env.example` → `.env.local` (defaults to therallyally-dev).
 * Production: Cloudflare Pages Production env (therallyally-prod).
 * See docs/INFRA/04_FIREBASE_PROJECTS.md — do not hardcode project ids here.
 */

function readEnv(name) {
  const value = process.env[name];
  return typeof value === "string" ? value.trim() : "";
}

const firebaseConfig = {
  apiKey: readEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: readEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: readEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: readEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: readEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: readEnv("REACT_APP_FIREBASE_APP_ID"),
  measurementId: readEnv("REACT_APP_FIREBASE_MEASUREMENT_ID"),
};

/** False when CRA env vars were not loaded (common if `.env.local` is missing). */
export function isFirebaseConfigReady() {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.projectId &&
      firebaseConfig.appId
  );
}

export default firebaseConfig;
